<template>
  <img
    v-show="!isHidden"
    :src="resolvedFlagUrl"
    :alt="`${countryCode} flag`"
    class="country-flag"
    :style="flagStyle"
    @error="onImageError"
  />
</template>

<script setup>
import { computed, defineProps, ref, watch } from "vue";
import { flagcdnFromCode } from "@components/utils/countryFlagIcon";

const props = defineProps({
  countryCode: {
    type: String,
    required: true,
  },
  flagUrl: {
    type: String,
    default: null,
  },
  size: {
    type: [String, Number],
    default: 15,
  },
});

const resolvedFlagUrl = computed(() => {
  if (props.flagUrl) {
    return props.flagUrl;
  }
  return flagcdnFromCode(props.countryCode);
});

const flagStyle = computed(() => {
  const height = typeof props.size === "number" ? props.size : parseInt(props.size, 10);
  const width = Math.round((height * 20) / 15);
  return {
    height: `${height}px`,
    width: `${width}px`,
  };
});

const isHidden = ref(false);

watch(resolvedFlagUrl, () => {
  isHidden.value = false;
});

const onImageError = (event) => {
  const fallbackUrl = flagcdnFromCode(props.countryCode);
  if (fallbackUrl && event.target.src !== fallbackUrl) {
    event.target.src = fallbackUrl;
    return;
  }
  isHidden.value = true;
};
</script>

<style scoped>
.country-flag {
  display: inline-block;
  border-radius: 2px;
  border: 0.5px solid #eaecf0;
  object-fit: contain;
  vertical-align: middle;
}
</style>
